export const tKey = 'core.payment_popup';